// TODO: investigate why this import is not working with '@db-access/clientIntakeForms'
import { PROVIDE_FB_CLIENT_INTAKE_FORMS_STATE } from 'libs/db-access/clientIntakeForms/src/index';
import { provideStates } from '@ngxs/store';

import { IntakeFormClientPortalState } from './state/intake-form-client-portal.state';

export const PROVIDE_INTAKE_FORM_CLIENT_PORTAL_STATE = [
	provideStates([IntakeFormClientPortalState]),
	...PROVIDE_FB_CLIENT_INTAKE_FORMS_STATE,
];
